import { Progress } from 'components/Custom/Progress'
import { Box, Link } from 'components/Material/index'
import React from 'react'

interface LoadingOrErrorComponentProps {
  isError: boolean
  refetch: () => void
}

export const LoadingItems: React.FC<LoadingOrErrorComponentProps> = ({ isError, refetch }) => {
  return (
    <Box className="flex justify-center py-10">
      {!isError && <Progress />}
      {isError && (
        <Box className="flex flex-col items-center gap-5">
          <Progress value={90} variant="determinate" />
          <Link className="cursor-pointer" onClick={refetch}>
            Erro! Tente Novamente
          </Link>
        </Box>
      )}
    </Box>
  )
}
